import { render, staticRenderFns } from "./MaterialImage.vue?vue&type=template&id=16d53c32&scoped=true"
import script from "./MaterialImage.vue?vue&type=script&lang=js"
export * from "./MaterialImage.vue?vue&type=script&lang=js"
import style0 from "./MaterialImage.vue?vue&type=style&index=0&id=16d53c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d53c32",
  null
  
)

export default component.exports